export default __webpack_public_path__ + "static/media/dark.84810092.svg";